import { useCallback, useEffect, useRef, useState } from "react"

// https://stackoverflow.com/questions/54954091/how-to-use-callback-with-usestate-hook-in-react
export function useStateCallback<T>(
    initialState: T,
): [T, (state: T | ((prev: T) => T), cb?: (newValues: T) => void) => void] {
    const [state, setState] = useState<T>(initialState)

    // init mutable ref container for callbacks
    const cbRef = useRef<any>(null)

    const setStateCallback = useCallback(
        (state: T | ((prev: T) => T), cb?: (newValues: T) => void) => {
            // store current, passed callback in ref
            cbRef.current = cb || null

            setState(state)
        },
        [],
    ) // keep object reference stable, exactly like `useState`

    useEffect(() => {
        // cb.current is `null` on initial render,
        // so we only invoke callback on state *updates*
        if (!cbRef.current) {
            return
        }

        cbRef.current(state)

        // reset callback after execution
        cbRef.current = null
    }, [state])

    return [state, setStateCallback]
}
